import styled from 'styled-components';
import { color } from './helpers/variables';

export const NoProductsFound = styled.p`
  max-width: 460px;
  margin: 200px auto 300px;
  font-size: 18px;
  font-weight: 300;
  font-style: italic;
  font-stretch: normal;
  line-height: 1.56;
  letter-spacing: normal;
  text-align: center;
  color: ${color.black};
`;



// WEBPACK FOOTER //
// ./src/styles/NoProductsFound.js